<app-main-navbar></app-main-navbar>

<div class="container-fluid">

  <h4 style="font-size: 18px;">Current Version: {{CURRENT_VERSION}}</h4>

  <br>

  <div class="d-flex gap-2 mb-3">
    <button class="btn btn-primary" (click)="createUser()">
      <i class="bi bi-plus-circle me-1"></i> Create User
    </button>
    <a class="btn btn-primary" routerLink="/admin-panel/benchmarks" routerLinkActive="active">
      <i class="bi bi-graph-up me-1"></i> Manage Benchmark Portfolios
    </a>
    <button
      class="btn btn-primary"
      (click)="openEmailComposer()"
      [disabled]="getSelectedCount() === 0"
    >
      <i class="bi bi-envelope me-1"></i>
      Send Notification ({{ getSelectedCount() }} selected)
    </button>
  </div>

  <br>

  <!-- Search and Filters -->
  <div class="d-flex gap-3 align-items-center mb-3">
    <div class="search-form flex-grow-1">
      <form [formGroup]="searchForm">
        <input class="form-control" type="text" id="searchTerm" formControlName="searchTerm" placeholder="Search by organisation or username">
      </form>
    </div>

    <!-- Email Filter Dropdown -->
    <div class="d-flex align-items-center gap-2">
      <label class="form-label mb-0 text-nowrap">Email:</label>
      <select class="form-select form-select-sm" style="width: auto;" [(ngModel)]="emailFilter" (change)="applyFilters()">
        <option value="all">All Users</option>
        <option value="with_email">With Email</option>
        <option value="without_email">Without Email</option>
      </select>
    </div>

    <!-- Notification Filter Dropdown -->
    <div class="d-flex align-items-center gap-2">
      <label class="form-label mb-0 text-nowrap">Notifications:</label>
      <select class="form-select form-select-sm" style="width: auto;" [(ngModel)]="notificationFilter" (change)="applyFilters()">
        <option value="all">All</option>
        <option value="enabled">Enabled</option>
        <option value="disabled">Disabled</option>
      </select>
    </div>

    <!-- Status Filter Dropdown -->
    <div class="d-flex align-items-center gap-2">
      <label class="form-label mb-0 text-nowrap">Status:</label>
      <select class="form-select form-select-sm" style="width: auto;" [(ngModel)]="statusFilter" (change)="applyFilters()">
        <option value="all">All</option>
        <option value="active">Active</option>
        <option value="inactive">Inactive</option>
      </select>
    </div>
  </div>

  <!-- Selection Controls -->
  <div class="d-flex gap-2 mb-2" *ngIf="showUsers">
    <button class="btn btn-primary" (click)="selectAllVisible()">
      Select All Visible
    </button>
    <button class="btn btn-primary" (click)="deselectAll()" [disabled]="getSelectedCount() === 0">
      Deselect All
    </button>
    <span class="text-muted align-self-center ms-2">
      {{ getSelectedCount() }} user(s) selected
    </span>
  </div>

  <br>

  <div class="spinner-border text-primary" role="status" *ngIf="loadingData">
    <span class="visually-hidden">Loading...</span>
  </div>

  <div class="table-container" style="margin:0;">
    <table class="table table-condensed table-hover" *ngIf="showUsers">
      <thead>
        <tr>
          <th style="width: 3%;">
            <input
              type="checkbox"
              class="form-check-input"
              #selectAllCheckbox
              (change)="selectAllCheckbox.checked ? selectAllVisible() : deselectAll()"
              [checked]="filteredData.length > 0 && getSelectedCount() === filteredData.length"
            >
          </th>
          <th style="width: 4%;">ID</th>
          <th style="width: 10%;">Organisation</th>
          <th style="width: 8%;">Username</th>
          <th style="width: 8%;">API Username</th>
          <th style="width: 14%;">Email</th>
          <th style="width: 5%;">Status</th>
          <th style="width: 5%;">Notify</th>
          <!-- <th style="width: 4%;">Sampling</th> -->
          <!-- <th style="width: 4%;">Excel</th> -->
          <th style="width: 13%;">Roles</th>
          <th style="width: 4%;">Edit</th>
          <th style="width: 4%;">Delete</th>
          <th style="width: 5%;">SIA Chat</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let user of filteredData | paginate:{id:'pag_1', itemsPerPage: 10, currentPage: paginator_1_page}">
          <td>
            <input
              type="checkbox"
              class="form-check-input"
              [checked]="isUserSelected(user.id)"
              (change)="toggleUserSelection(user.id)"
            >
          </td>
          <td>{{ user.id }}</td>
          <td>{{ user.organisation }}</td>
          <td>{{ user.username }}</td>
          <td>{{ user.api_username }}</td>
          <td>
            <span *ngIf="hasEmail(user)" class="text-success">
              <i class="bi bi-envelope-check me-1"></i>
              {{ user.email }}
            </span>
            <span *ngIf="!hasEmail(user)" class="text-warning">
              <i class="bi bi-envelope-x me-1"></i>
              No email
            </span>
          </td>
          <td>
            <span [class]="user.is_active ? 'badge bg-success' : 'badge bg-danger'">
              {{ user.is_active ? 'Active' : 'Inactive' }}
            </span>
          </td>
          <td>
            <i
              [class]="user.notification_enabled ? 'bi bi-bell-fill text-success' : 'bi bi-bell-slash text-danger'"
              [matTooltip]="user.notification_enabled ? 'Notifications enabled' : 'Notifications disabled'"
            ></i>
          </td>
          <!-- <td>
            <i [class]="user.allow_sampling ? 'bi bi-check-circle text-success' : 'bi bi-x-circle text-danger'"></i>
          </td>
          <td>
            <i [class]="user.allow_excel_download ? 'bi bi-check-circle text-success' : 'bi bi-x-circle text-danger'"></i>
          </td> -->
          <td>{{ user.roles.join(', ') }}</td>
          <td><i class="bi bi-pen cursor-pointer" (click)="editUser(user)"></i></td>
          <td><i class="bi bi-trash cursor-pointer text-danger" (click)="deleteUser(user)"></i></td>
          <td><i class="bi bi-download cursor-pointer" (click)="downloadSIAChat(user)"></i></td>
        </tr>
      </tbody>
    </table>

    <pagination-controls id="pag_1" [maxSize]="10" (pageChange)="paginator_1_page = $event"
      style="align-items: flex-start;">
    </pagination-controls>
  </div>
</div>
